import { z } from "zod";

/**
 * Agent profile picture schemas — multipart upload + AI regeneration.
 *
 * The upload body is FormData (frontend typing only; multer parses the file
 * server-side, so there is no JSON body to validate on that route).
 */

export const AgentProfilePictureFormDataBodySchema = z.custom<FormData>();

/** Optimized image result: original URL + generated size variants. */
export const AgentProfilePictureResultSchema = z.object({
  original: z.string(),
  sizes: z.record(z.string(), z.string()),
  default: z.string(),
  message: z.string()
});

export type AgentProfilePictureResult = z.infer<typeof AgentProfilePictureResultSchema>;

export const RegenerateProfilePictureBodySchema = z.object({
  customPrompt: z.string().optional()
});
